<template>
    <div class="container">
        <div>
            <section class="container is-max-desktop">
                <div class="is-flex">
                    <p class="title has-text-weight-bold">Mentor</p>
                </div>
                <div class="p-2">
                    <strong>Q. How do I become a mentor?</strong><br />
                    <strong>Ans. </strong>To become a mentor, simply register as a mentor and await verification of your
                    account.
                    <br /><br />
                    <strong>Q. What should the profile URL be?</strong> <br />
                    <strong>Ans. </strong>The profile URL should direct to a platform where your abilities and expertise are
                    detailed.
                    <br /> <br />
                    <strong>Q. I inadvertently accepted a mentee's mentorship request. How can I reverse this
                        action?</strong><br />
                    <strong>Ans. </strong>You can now mark that mentorship request as completed or rejected on "My Mentees"
                    page. If you reconsider, you can adjust the status of the mentorship back to ongoing.
                    <br /><br />
                    <strong>Q. How can I prevent receiving new mentee requests?</strong><br />
                    <strong>Ans. </strong>Navigate to the mentor preference page and deselect the "Accept new mentee"
                    checkbox.
                    <br /><br />
                </div>
            </section>
            <section class="container is-max-desktop">
                <div class="is-flex">
                    <p class="title has-text-weight-bold">Mentee</p>
                </div>
                <div class="p-2">
                    <strong>Q. How do I become a mentee?</strong><br />
                    <strong>Ans. </strong>To become a mentee, simply register as a mentee.
                    <br /><br />
                    <strong>Q. What should the profile URL be?</strong> <br />
                    <strong>Ans. </strong>The profile URL should direct to a platform where your abilities and expertise are
                    detailed.
                    <br /> <br />
                    <strong>Q. How can I retract a mentorship request sent to a mentor by mistake?</strong><br />
                    <strong>Ans. </strong>Navigate to the pending request page and cancel the mentorship request.
                    <br /><br />
                    <strong>Q. Is it possible to engage in multiple mentorships under the same mentor?</strong><br />
                    <strong>Ans. </strong>Yes, you can, but each mentorship would typically involve different projects.
                    <br /><br />
                </div>
            </section>
        </div>
    </div>
</template>
  
<script>
import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            logged_in: 'logged_in',
        }),
        ...mapState({
            user: 'user',
        }),
    },
};
</script>
  